import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, signal, TemplateRef, viewChild } from '@angular/core';
import { ActionButtonComponent } from 'src/app/home-page/components/action-button/action-button.component';
import { CarouselArrowsComponent } from 'src/app/home-page/components/carousel-arrows/carousel-arrows.component';
import { PreviewCardComponent } from 'src/app/home-page/components/preview-card/preview-card.component';
import { SectionTitleComponent } from 'src/app/home-page/components/section-title/section-title.component';
import { CarouselBaseComponent } from 'src/app/home-page/components/carousel-base/carousel-base.component';
import { CarouselService } from '../../services/carousel.service';
import { PreviewCard } from 'src/app/home-page/components/preview-card/preview-card.class';
import { Subscription, Subject } from 'rxjs';
import { IPreviewCard } from 'src/app/home-page/components/preview-card/IPreviewClass';
import { NavigationService } from '@core/services/navigation.service';
import { environment } from '@environments/environment';
import { CarouselItemBase } from 'src/app/home-page/components/carousel-base/carousel-item-base.model';
import { SearchConfig } from '@core/services/search-engine/search.config';
import { SwiperOptions } from 'swiper/types';
import { CAROUSEL_BASE_DEFAULT_CONFIG } from 'src/app/home-page/components/carousel-base/carousel-base.default-config';
import { Autoplay, Grid, Pagination } from 'swiper/modules';

@Component({
  selector: 'cgw-categories-section',
  standalone: true,
  imports: [
    ActionButtonComponent,
    SectionTitleComponent,
    CommonModule,
    CarouselArrowsComponent,
    CarouselBaseComponent,
    PreviewCardComponent,
  ],
  templateUrl: './categories-section.component.html',
  styleUrl: './categories-section.component.scss',
})
export class CategoriesSectionComponent implements OnInit, OnDestroy {
  private readonly _categoryTemplateRef = viewChild('categoryTemplate', { read: TemplateRef });

  public readonly carousel =
    viewChild<CarouselBaseComponent<PreviewCard, CarouselItemBase<PreviewCard>>>(
      CarouselBaseComponent,
    );
  public readonly carouselConfig = signal<SwiperOptions>({
    ...CAROUSEL_BASE_DEFAULT_CONFIG,
    modules: [Autoplay, Pagination, Grid],
    slidesPerView: 1,
    spaceBetween: 10,
    grid: {
      rows: 2,
      fill: 'row',
    },
    breakpoints: {
      370: {
        grid: {
          rows: 2,
          fill: 'row',
        },
        slidesPerView: 2,
      },
      576: {
        grid: {
          rows: 2,
          fill: 'row',
        },
        slidesPerView: 1,
      },
      768: {
        grid: {
          rows: 2,
          fill: 'row',
        },
        slidesPerView: 3,
      },
      992: {
        grid: {
          rows: 2,
          fill: 'row',
        },
        slidesPerView: 4,
      },
    },
  });
  public readonly carouselItems = signal<CarouselItemBase<PreviewCard>[]>([]);
  public readonly mainCategory = signal<PreviewCard | null>(null);
  private categoriesSubscription$: Subscription;

  constructor(
    private carouselService: CarouselService,
    private navigationService: NavigationService,
  ) {}

  public ngOnInit(): void {
    this.categoriesSubscription$ = this.carouselService.getCategories().subscribe((categories) => {
      const categoriesCards: PreviewCard[] = [];

      categories.forEach((category) => {
        let categoryCard: IPreviewCard = {
          id: category.id_agrupador,
          title: category.agrupador.nombre,
          class: category.id_carrusel_agrupador_tipo == 1 ? 'category-max' : 'category-min',
          backgroundImages: category.imagenes.map((image) => ({
            ...image,
            imagen: environment.apiImageStatic + '/home_carrusel_agrupadores/' + image.imagen,
          })),
          onClick: () => {
            this.navigationService.navigateUrlWithoutPersistence(['productos'], {
              queryParams: { [SearchConfig.grouperProp]: category.id_agrupador },
            });
          },
        };
        categoriesCards.push(new PreviewCard(categoryCard));
      });

      this.mainCategory.set(categoriesCards.find((category) => category.class == 'category-max'));
      this.carouselItems.set(
        categoriesCards.reduce((acc, cat) => {
          if (cat.class !== 'category-max')
            acc.push(
              new CarouselItemBase({
                id: cat.id,
                data: cat,
                templateRef: this._categoryTemplateRef(),
                templateContext: { item: cat },
              }),
            );
          return acc;
        }, []),
      );
    });
  }

  public ngOnDestroy(): void {
    this.categoriesSubscription$?.unsubscribe();
  }
}
